const S = {};

S.fieldLabel = {
  marginRight: '10px',
  width: '87px',
  display: 'inline-block',
  textAlign: 'right',
  verticalAlign: 'top',
  fontWeight: 'bold',
};

S.fieldData = {
  display: 'inline-block',
  width: '184px',
  verticalAlign: 'top',
};

S.LongFieldLabel = {
  marginRight: '5px',
  width: '87px',
  display: 'block',
  textAlign: 'right',
  verticalAlign: 'top',
  fontWeight: 'bold',
  float: 'left',
};

S.LongfieldData = {
  width: '187px',
  display: 'block',
  float: 'right',
  paddingLeft: '4px',
  verticalAlign: 'top',
  paddingBottom: '10px',
};

S.detailView = {
  position: 'relative',
};

S.titleText = {
  fontSize: '24px',
  flex: 'auto',
};

export default S;
